import React, { PureComponent } from "react";
import ReactDOM from "react-dom";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import {
  CustomizedXAxisTickTime,
  CustomizedYAxisTick,
  selectFormat,
  Error,
  StandardTooltip,
  MAIN_COLORS,
  formatDateFromData,
} from "./../../../Utils/Utils.js";

import { Tooltip as ReactTooltip } from "react-tooltip";

const createLabel = (key, value, color) => (
  <div className="standard-tooltip__item" key={key}>
    <span className="standard-tooltip__key">
      <span
        className="standard-tooltip__icon"
        style={{ background: color }}
      ></span>
      {key}
    </span>
    <span className="standard-tooltip__value">
      {selectFormat("number", value)}
    </span>
  </div>
);

class ViewsComparison extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      networks: [],
      data: [],
    };
  }

  componentDidMount() {
    this.props.childRef(this);
  }

  clickGraphLegend = (event) => {
    const value = event.value.props["data-name"];
    let arr = this.state.networks.slice(0);

    // Legends
    const node = ReactDOM.findDOMNode(this.refs.social_graph);
    const list_elements = node.querySelectorAll(".recharts-legend-item");
    // Select clicked legend
    for (let i = 0; i < list_elements.length; i++) {
      if (list_elements[i].querySelector("div").dataset.name === value) {
        list_elements[i]
          .querySelector(".recharts-symbols")
          .classList.toggle("recharts-symbols--off");
        list_elements[i]
          .querySelector(".recharts-legend-item-text")
          .classList.toggle("recharts-legend-item-text--off");
      }
    }

    // create an array of networks
    if (arr.indexOf(value) === -1) {
      arr.push(value);
    } else {
      arr.splice(arr.indexOf(value), 1);
    }

    this.setState({ networks: arr });
  };

  renderGraph = (data, series, networks) => {
    const filteredSeries = series.filter((d) => !networks.includes(d.name));

    return [
      <ResponsiveContainer key="views-comp" height={250}>
        <LineChart
          height={250}
          data={data}
          margin={{
            top: 20,
            right: 0,
            left: 5,
            bottom: 0,
          }}
          ref="social_graph"
        >
          <Tooltip
            cursor={{ fill: "#eee", opacity: 0.5 }}
            content={
              <StandardTooltip
                render={({ data }) => {
                  const payload = data(this.props);

                  if (payload !== null) {
                    // create the labels based on each element from the payload
                    let labels = payload.map((p) =>
                      createLabel(p.dataKey, p.value, p.color)
                    );
                    let selected_date = payload[0].payload.date;
                    return (
                      <div className="standard-tooltip">
                        <header className="standard-tooltip__header">
                          <span className="standard-tooltip__key-header">
                            Date:
                          </span>
                          <span className="standard-tooltip__value-header">
                            {selected_date}
                          </span>
                        </header>
                        <main className="standard-tooltip__main">{labels}</main>
                      </div>
                    );
                  }
                }}
              />
            }
          />

          <CartesianGrid
            stroke="#FEE5DE"
            strokeDasharray="3 3"
            vertical={false}
          />

          <Legend
            verticalAlign="top"
            align="left"
            iconType="square"
            iconSize={15}
            height={65}
            onClick={this.clickGraphLegend}
            payload={series.map((s) => ({
              value: (
                <div
                  data-name={s.name}
                  style={{ display: "inline-block", marginRight: "5px" }}
                  data-tooltip-id="chart-icon-tooltip"
                  data-tooltip-html={s.name}
                >
                  {s.thumbnail ? (
                    <img src={s.thumbnail} alt="" width="25" height="25" />
                  ) : (
                    s.name
                  )}
                </div>
              ),
              color: s.color,
              type: "square",
            }))}
          />

          {filteredSeries.map((item) => (
            <Line
              key={item.name}
              type="monotone"
              dataKey={item.name}
              stroke={item.color}
              strokeWidth={2}
              dot={false}
            />
          ))}
          <XAxis
            dataKey="date"
            axisLine={false}
            tickLine={false}
            interval="preserveStartEnd"
            scale="point"
            tick={<CustomizedXAxisTickTime />}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            mirror={true}
            tick={<CustomizedYAxisTick />}
          />
        </LineChart>
      </ResponsiveContainer>,
      <ReactTooltip
        key="views-comp-tooltip"
        id="chart-icon-tooltip"
        className="title-tooltip"
      />,
    ];
  };

  getExportData = () => {
    const { networks } = this.state;
    const data = this.props.data.data.map((d) => {
      const _d = {};
      _d.date = d.date.date;
      d.creators.forEach(
        (c) => !networks.includes(c.name) && (_d[c.name] = c.views)
      );
      return _d;
    });
    return {
      data,
      opts: {
        type: "chart",
        date: {
          defined: true,
          format: "YYYY-MM-DD",
        },
      },
    };
  };

  render() {
    let graphData = this.props.data;

    if (graphData.hasData === false) {
      return <Error minHeight={360} />;
    }

    const thumbnails = graphData.meta.thumbnails;

    const seriesNames = [];
    const data = formatDateFromData(this.props.data.data, "YYYY/MM/DD").map(
      (d) => {
        const _d = {};
        _d.date = d.date.date;
        d.creators.forEach((c) => {
          if (!seriesNames.includes(c.name)) seriesNames.push(c.name);
          _d[c.name] = c.views;
        });
        return _d;
      }
    );

    const series = seriesNames.map((d, i) => ({
      name: d,
      color: MAIN_COLORS[i],
      thumbnail:
        thumbnails && thumbnails.find((t) => t.creator === d).thumbnail,
    }));
    return this.renderGraph(data, series, this.state.networks);
  }
}

export default ViewsComparison;
